var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"text":"_2JNJr","lineClamp":"_10Hfi"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._2JNJr{margin:0;padding:0;font-size:inherit;font-weight:inherit;overflow:hidden}"+wrap+" ._10Hfi{display:-webkit-box;-webkit-box-orient:vertical;white-space:normal}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

